import RelatedContentCard from '@klv/molecules/related-content-card';
import { generateClassName } from '@klv/shared/utils/functions';

import * as s from './styles/relatedContent.module.scss';

import type { IRelatedContent } from './types';

const RelatedContent = ({
  background, cards, headline = '', solidCardHoverColor = 'none', ...props
}: IRelatedContent) => (
  <div
    className={
      generateClassName([
        s.relatedContent,
        s[background],
      ])
    }
    {...props}
  >
    <div className={generateClassName([s.relatedContentGrid, 'grid', 'defaultPaddingTop'])}>
      {headline && (
        <div
          className={
            generateClassName([
              s.headline,
              s[background],
              "h3"
            ])
          }
        >
          {headline}
        </div>
      )}
      <div
        className={
          generateClassName([
            s.cardContainerWrapper,
            "defaultPaddingBottom"
          ])
        }
      >
        <div
          className={s.cardContainer}
          style={{
            '--card-count': cards?.length,
          } as React.CSSProperties}
        >
          {cards && cards.map((card) => (
            <RelatedContentCard
              {...card.relatedContentCard}
              key={JSON.stringify(card.relatedContentCard)}
              solidCardHoverColor={solidCardHoverColor}
              variant={background === 'dark' ? 'dark' : 'light'}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default RelatedContent;
